import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ContractListItemDto } from "../../../autogen/bff-api";
import { urls } from "../../../urls";
import { requireCounterparty } from "../../contracts/typeguards";
import { getCounterpartyName } from "../../contracts/view-all/ContractRow";
import { ProfileImageRounded } from "../../sourcing-events/buyer/view-all/ProfileImageRounded";

interface Props {
  contract: ContractListItemDto;
}

export const Contract = ({ contract }: Props) => {
  const navigate = useNavigate();

  const counterparty = requireCounterparty(contract);
  const name = getCounterpartyName(counterparty);

  return (
    <Flex
      key={contract.id}
      width="full"
      minHeight="50px"
      borderRadius={"6px"}
      mt="15px"
      padding={"10px"}
      backgroundColor="smBackgroundSecondary"
      cursor="pointer"
      _hover={{ backgroundColor: "rgba(49, 151, 149, 0.08)" }}
      onClick={() => {
        navigate(urls.contracts.viewSingle.go(contract.id));
      }}
    >
      <Grid
        w="100%"
        key={contract.id}
        gridTemplateAreas={`
            "title counterparty"
            "sub counterparty"
            `}
        gridTemplateColumns={"1fr 200px"}
      >
        <GridItem area={"title"}>
          <Flex flex={3} alignItems={"center"} paddingLeft="10px">
            <Text fontSize={"md"} color="smMuted">
              {contract.title}
            </Text>
          </Flex>
        </GridItem>
        <GridItem area={"sub"}>
          <Flex flex={4} alignItems={"center"} paddingLeft="10px">
            <Text
              fontSize={"sm"}
              fontWeight={"light"}
              color="smMuted"
            >{`${contract.internalOwner.firstName} ${contract.internalOwner.lastName}`}</Text>
          </Flex>
        </GridItem>
        <GridItem area={"counterparty"} display={"flex"} justifyContent={"end"} alignItems={"center"}>
          <Flex>
            <Flex>
              <ProfileImageRounded
                name={contract.internalOwner.firstName ?? undefined}
                backgroundColor={"smPrimary"}
                width={"20px"}
                fontSize="xx-small"
              />
            </Flex>
            <Flex mt="-2px" ml="5px">
              <Text fontSize={"sm"} color="smMuted">
                {name}
              </Text>
            </Flex>
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
};
